import {  FromObservable  } from './FromObservable';

export const from = FromObservable.create;


// WEBPACK FOOTER //
// ./~/rxjs/src/observable/from.ts